module.exports = __webpack_public_path__ + "img/Logotipo.9ad7214c.png";